import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ContentGrid,
  DocsContent,
  ParagraphText,
  TableOfContentsWrapper,
} from '../../styles';
import { TableOfContents } from '../../components/TableOfContents/TableOfContents';
import { MarkdownDoc } from '../../components/MarkdownDoc';
import { useMarkdownDoc } from '../../hooks/useMarkdownDoc';

interface GettingStartedTabContentProps {
  selectedTabId: string;
}

export function GettingStartedTabContent({
  selectedTabId,
}: GettingStartedTabContentProps) {
  const { hash } = useLocation();
  const { markdown, isLoading, hasError } = useMarkdownDoc(
    '/docs/landing-page-guide/getting-started.md',
  );

  useEffect(() => {
    if (!markdown || !hash) {
      return;
    }

    const sectionId = decodeURIComponent(hash.slice(1));
    if (!sectionId) {
      return;
    }

    window.requestAnimationFrame(() => {
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }, [hash, markdown]);

  return (
    <ContentGrid>
      <DocsContent>
        {isLoading ? <ParagraphText>Loading article...</ParagraphText> : null}
        {hasError ? (
          <ParagraphText>
            Unable to load this article. Please try again later.
          </ParagraphText>
        ) : null}
        {markdown ? <MarkdownDoc markdown={markdown} variant="tab" /> : null}
      </DocsContent>

      <TableOfContentsWrapper>
        <TableOfContents selectedTabId={selectedTabId} />
      </TableOfContentsWrapper>
    </ContentGrid>
  );
}
